import city_AEJson from '../assets/cities/city_AE.json';
import city_AMJson from '../assets/cities/city_AM.json';
import city_ARJson from '../assets/cities/city_AR.json';
import city_ATJson from '../assets/cities/city_AT.json';
import city_BAJson from '../assets/cities/city_BA.json';
import city_BRJson from '../assets/cities/city_BR.json';
import city_CAJson from '../assets/cities/city_CA.json';
import city_CHJson from '../assets/cities/city_CH.json';
import city_CLJson from '../assets/cities/city_CL.json';
import city_COJson from '../assets/cities/city_CO.json';
import city_ECJson from '../assets/cities/city_EC.json';
import city_FIJson from '../assets/cities/city_FI.json';
import city_GBJson from '../assets/cities/city_GB.json';
import city_GEJson from '../assets/cities/city_GE.json';
import city_HRJson from '../assets/cities/city_HR.json';
import city_HUJson from '../assets/cities/city_HU.json';
import city_IEJson from '../assets/cities/city_IE.json';
import city_IMJson from '../assets/cities/city_IM.json';
import city_INJson from '../assets/cities/city_IN.json';
import city_KEJson from '../assets/cities/city_KE.json';
import city_MEJson from '../assets/cities/city_ME.json';
import city_MXJson from '../assets/cities/city_MX.json';
import city_NOJson from '../assets/cities/city_NO.json';
import city_NZJson from '../assets/cities/city_NZ.json';
import city_PEJson from '../assets/cities/city_PE.json';
import city_PYJson from '../assets/cities/city_PY.json';
import city_RSJson from '../assets/cities/city_RS.json';
import city_SIJson from '../assets/cities/city_SI.json';
import city_SVJson from '../assets/cities/city_SV.json';
import city_UYJson from '../assets/cities/city_UY.json';
import city_XKJson from '../assets/cities/city_XK.json';
import names_AEJson from '../assets/names/names_AE.json';
import names_AMJson from '../assets/names/names_AM.json';
import names_ARJson from '../assets/names/names_AR.json';
import names_ATJson from '../assets/names/names_AT.json';
import names_BAJson from '../assets/names/names_BA.json';
import names_BRJson from '../assets/names/names_BR.json';
import names_CAJson from '../assets/names/names_CA.json';
import names_CLJson from '../assets/names/names_CL.json';
import names_COJson from '../assets/names/names_CO.json';
import names_ECJson from '../assets/names/names_EC.json';
import names_FIJson from '../assets/names/names_FI.json';
import names_GBJson from '../assets/names/names_GB.json';
import names_GEJson from '../assets/names/names_GE.json';
import names_HRJson from '../assets/names/names_HR.json';
import names_HUJson from '../assets/names/names_HU.json';
import names_IEJson from '../assets/names/names_IE.json';
import names_IMJson from '../assets/names/names_IM.json';
import names_INJson from '../assets/names/names_IN.json';
import names_KEJson from '../assets/names/names_KE.json';
import names_MEJson from '../assets/names/names_ME.json';
import names_MXJson from '../assets/names/names_MX.json';
import names_NOJson from '../assets/names/names_NO.json';
import names_NZJson from '../assets/names/names_NZ.json';
import names_PEJson from '../assets/names/names_PE.json';
import names_PYJson from '../assets/names/names_PY.json';
import names_RSJson from '../assets/names/names_RS.json';
import names_SIJson from '../assets/names/names_SI.json';
import names_SVJson from '../assets/names/names_SV.json';
import names_UYJson from '../assets/names/names_UY.json';
import names_XKJson from '../assets/names/names_XK.json';
import { AcceptedCountries } from '../data-types/international/internationalEnums';
import { City } from '../data-types/supercharged-bet/superchargedBetInterfaces';

export const getCitiesByCountry = (country: AcceptedCountries): City[] | null => {
  switch (country) {
    case AcceptedCountries.GREAT_BRITAIN:
      return city_GBJson;
    case AcceptedCountries.BOSNIA_AND_HERZEGOVINA:
      return city_BAJson;
    case AcceptedCountries.UNITED_ARAB_EMIRATES:
      return city_AEJson;
    case AcceptedCountries.ARGENTINA:
      return city_ARJson;
    case AcceptedCountries.ARMENIA:
      return city_AMJson;
    case AcceptedCountries.AUSTRIA:
      return city_ATJson;
    case AcceptedCountries.BRAZIL:
      return city_BRJson;
    case AcceptedCountries.CANADA:
      return city_CAJson;
    case AcceptedCountries.CHILE:
      return city_CLJson;
    case AcceptedCountries.COLOMBIA:
      return city_COJson;
    case AcceptedCountries.ECUADOR:
      return city_ECJson;
    case AcceptedCountries.FINLAND:
      return city_FIJson;
    case AcceptedCountries.GEORGIA:
      return city_GEJson;
    case AcceptedCountries.CROATIA:
      return city_HRJson;
    case AcceptedCountries.HUNGARY:
      return city_HUJson;
    case AcceptedCountries.INDIA:
      return city_INJson;
    case AcceptedCountries.IRELAND:
      return city_IEJson;
    case AcceptedCountries.KENYA:
      return city_KEJson;
    case AcceptedCountries.KOSOVO:
      return city_XKJson;
    case AcceptedCountries.MEXICO:
      return city_MXJson;
    case AcceptedCountries.MONTENEGRO:
      return city_MEJson;
    case AcceptedCountries.NORWAY:
      return city_NOJson;
    case AcceptedCountries.NEW_ZEALAND:
      return city_NZJson;
    case AcceptedCountries.PERU:
      return city_PEJson;
    case AcceptedCountries.PARAGUAY:
      return city_PYJson;
    case AcceptedCountries.EL_SALVADOR:
      return city_SVJson;
    case AcceptedCountries.SERBIA:
      return city_RSJson;
    case AcceptedCountries.SLOVENIA:
      return city_SIJson;
    case AcceptedCountries.SWITZERLAND:
      return city_CHJson;
    case AcceptedCountries.URUGUAY:
      return city_UYJson;
    case AcceptedCountries.ISLE_OF_MAN:
      return city_IMJson;

    default:
      return null;
  }
};

export const getNamesByCountry = (country: AcceptedCountries) => {
  switch (country) {
    case AcceptedCountries.GREAT_BRITAIN:
      return names_GBJson;
    case AcceptedCountries.BOSNIA_AND_HERZEGOVINA:
      return names_BAJson;
    case AcceptedCountries.UNITED_ARAB_EMIRATES:
      return names_AEJson;
    case AcceptedCountries.ARGENTINA:
      return names_ARJson;
    case AcceptedCountries.ARMENIA:
      return names_AMJson;
    case AcceptedCountries.AUSTRIA:
      return names_ATJson;
    case AcceptedCountries.BRAZIL:
      return names_BRJson;
    case AcceptedCountries.CANADA:
      return names_CAJson;
    case AcceptedCountries.CHILE:
      return names_CLJson;
    case AcceptedCountries.COLOMBIA:
      return names_COJson;
    case AcceptedCountries.ECUADOR:
      return names_ECJson;
    case AcceptedCountries.FINLAND:
      return names_FIJson;
    case AcceptedCountries.GEORGIA:
      return names_GEJson;
    case AcceptedCountries.CROATIA:
      return names_HRJson;
    case AcceptedCountries.HUNGARY:
      return names_HUJson;
    case AcceptedCountries.INDIA:
      return names_INJson;
    case AcceptedCountries.IRELAND:
      return names_IEJson;
    case AcceptedCountries.KENYA:
      return names_KEJson;
    case AcceptedCountries.KOSOVO:
      return names_XKJson;
    case AcceptedCountries.MEXICO:
      return names_MXJson;
    case AcceptedCountries.MONTENEGRO:
      return names_MEJson;
    case AcceptedCountries.NORWAY:
      return names_NOJson;
    case AcceptedCountries.NEW_ZEALAND:
      return names_NZJson;
    case AcceptedCountries.PERU:
      return names_PEJson;
    case AcceptedCountries.PARAGUAY:
      return names_PYJson;
    case AcceptedCountries.EL_SALVADOR:
      return names_SVJson;
    case AcceptedCountries.SERBIA:
      return names_RSJson;
    case AcceptedCountries.SLOVENIA:
      return names_SIJson;
    case AcceptedCountries.URUGUAY:
      return names_UYJson;
    case AcceptedCountries.ISLE_OF_MAN:
      return names_IMJson;

    default:
      return null;
  }
};
